import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/pro-light-svg-icons/faEllipsis';
import { TypedMemo } from '../../../../common/types';
import { songPageMessages } from './songPageMessages';
import { mergeMessages } from '../../merge/mergeMessages';

interface SongPageMenuProps {
  isClaimed: boolean;
  /** False for the demo artist: Remove is not in the menu (f7). */
  canRemove: boolean;
  onCopyLink: () => void;
  onEditLyrics: () => void;
  onRemove: () => void;
  /** "Merge with another song…" (design catalog-merge a1). Undefined: not in the menu. */
  onMerge?: () => void;
}

/** The menu of the song page head (design b1, a2): copy the link, the lyrics, remove. */
const SongPageMenuComponent: React.FC<SongPageMenuProps> = ({
  isClaimed,
  canRemove,
  onCopyLink,
  onEditLyrics,
  onRemove,
  onMerge,
}) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => setIsOpen((open) => !open), []);

  return (
    <Dropdown isOpen={isOpen} toggle={toggle} direction="down">
      <DropdownToggle
        color="link"
        className="btn btn-outline-secondary"
        aria-label={intl.formatMessage(songPageMessages.menu)}
      >
        <FontAwesomeIcon icon={faEllipsis} />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem onClick={onEditLyrics}>{intl.formatMessage(songPageMessages.menuEditLyrics)}</DropdownItem>
        <DropdownItem onClick={onCopyLink}>{intl.formatMessage(songPageMessages.menuCopyLink)}</DropdownItem>
        {onMerge !== undefined && (
          <DropdownItem onClick={onMerge}>{intl.formatMessage(mergeMessages.menu)}</DropdownItem>
        )}
        {canRemove && (
          <>
            <DropdownItem divider />
            <DropdownItem className="text-danger" onClick={onRemove}>
              {intl.formatMessage(isClaimed ? songPageMessages.menuUnclaim : songPageMessages.menuRemove)}
            </DropdownItem>
          </>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export const SongPageMenu = TypedMemo(SongPageMenuComponent);
